import Color from 'color';

import type {WithThemeProp} from '../theme';
import type {ThemeAndAnyKnownColor} from '../theme/colors';

import {getColor} from './getColor';

export type BlackoutWeight = 'extra' | 'light' | 'medium' | 'strong';

const getMixRatio = (weight: BlackoutWeight) => {
  switch (weight) {
    case 'extra':
      return 0.8;
    case 'light':
      return 0.2;
    case 'medium':
      return 0.4;
    case 'strong':
      return 0.6;
    default:
      return 0.5;
  }
};

export const getBlackoutColor =
  (color: ThemeAndAnyKnownColor, weight: BlackoutWeight) =>
  <ComponentProps extends WithThemeProp>(p: ComponentProps) => {
    const themeColor = getColor(color)(p);

    const ratio = getMixRatio(weight);

    return Color(themeColor).mix(Color('black'), ratio).toString();
  };
